if (!customElements.get('aurlona-footer-menu')) {
  customElements.define('aurlona-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();

      const heading = this.querySelector(':scope > .hdt-heading-f');
      const content = this.querySelector(':scope > .hdt-collapse-content');
      if (!heading || !content) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      const mobile = window.matchMedia('(max-width: 767px)');
      const enabled = Boolean(this.closest('.hdt-footer-collapse-true'));
      const defaultOpen = this.classList.contains('hdt-footer-newsletter');
      let open = defaultOpen;

      const sync = () => {
        const collapsible = enabled && mobile.matches;
        if (!collapsible) open = defaultOpen;

        this.classList.toggle('open', collapsible && open);
        content.style.removeProperty('height');
        content.inert = collapsible && !open;

        if (collapsible) {
          heading.setAttribute('role', 'button');
          heading.setAttribute('tabindex', '0');
          heading.setAttribute('aria-controls', content.id);
          heading.setAttribute('aria-expanded', String(open));
          content.setAttribute('aria-hidden', String(!open));
          if (open) content.style.height = 'auto';
        } else {
          heading.removeAttribute('role');
          heading.removeAttribute('tabindex');
          heading.removeAttribute('aria-controls');
          heading.removeAttribute('aria-expanded');
          content.removeAttribute('aria-hidden');
        }
      };

      const toggle = () => {
        if (!enabled || !mobile.matches) return;
        open = !open;
        sync();
      };

      heading.addEventListener('click', toggle, { signal });
      heading.addEventListener('keydown', (event) => {
        if (!enabled || !mobile.matches || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        toggle();
      }, { signal });
      mobile.addEventListener('change', sync, { signal });
      sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
